/**
 * API endpoints for players
 */
export class PlayersAPI {
    apiClient;
    controllerUrl;
    /**
     * Create a new PlayersAPI
     * @param apiClient - The API client
     * @param baseUrl - The base URL for API requests
     */
    constructor(apiClient, baseUrl) {
        this.apiClient = apiClient;
        this.controllerUrl = `${baseUrl}/Players`;
    }
    /**
     * Get multiple player profiles
     * @param params - Query parameters
     * @returns Promise with the players
     */
    async get(params = {}) {
        return this.apiClient.get(this.controllerUrl, params);
    }
    /**
     * Get a player by username
     * @param username - The username
     * @returns Promise with the player
     */
    async getPlayer(username) {
        const url = `/${username}`;
        return this.apiClient.get(this.controllerUrl + url);
    }
    /**
     * Get a player's course ratings
     * @param username - The username
     * @param course - The course
     * @returns Promise with the ratings
     */
    async getPlayerCourseRatings(username, course) {
        const url = `/${username}/courses/${course}/ratings`;
        return this.apiClient.get(this.controllerUrl + url);
    }
}
